module.exports = __webpack_public_path__ + "img/sticky.2171c450.png";